import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { SupportRequestDialogComponent } from "./support-request-dialog.component";

export const SUPPORT_REQUEST_DIALOG_ID = "support-request-dialog";

@Component({
  selector: "support",
  templateUrl: "./support.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, MatTooltipModule],
})
export class SupportComponent {
  private readonly _dialog = inject(MatDialog);

  openSupportDialog(): void {
    if (this._dialog.getDialogById(SUPPORT_REQUEST_DIALOG_ID)) {
      return;
    }

    this._dialog.open(SupportRequestDialogComponent, {
      id: SUPPORT_REQUEST_DIALOG_ID,
      autoFocus: "first-tabbable",
      restoreFocus: true,
      width: "34rem",
      maxWidth: "calc(100vw - 2rem)",
    });
  }
}
